import { combineReducers } from 'redux'
// Reducers
/* eslint-disable */
import activities from './api/activities'
import actions from './api/actions'
import ajEvents from './api/aj-events'
import ajTemplates from './api/aj-templates'
import awards from './api/awards'
import awardsProgressOverview from './api/awardsProgressOverview'
import bulk from './api/bulk'
import organizations from './api/organizations'
import codeLists from './api/code-lists'
import common from './api/common'
import leaders from './api/leaders'
import leadersOverview from './api/leadersOverview'
import participants from './api/participants'
import persons from './api/persons'
import tasks from './api/tasks'
import assessor from './api/assessor'
import assessors from './api/assessors'
import announcements from './api/announcements'
import residentialProjects from './api/residential-projects'
import configuration from './api/configuration'
import payments from './api/payments'
import parentalConsent from './api/parental-consent'
import contacts from './api/contacts'
import profileQuestions from './api/profile-questions'
import blobs from './api/blobs'
import reports from './api/reports'
import search from './api/search'
import dataImport from './api/data-import'
import translationsManagement from './api/translations-management'
import apiKeys from './api/api-keys'
import messages from './api/messages'
import translations from './api/translations'
import metrics from './api/metrics'
import badges from './api/badges'
import labels from './api/labels'
import lists from './api/lists'

// Export Actions
export * as activities from './api/activities'
export * as actions from './api/actions'
export * as ajEvents from './api/aj-events'
export * as ajTemplates from './api/aj-templates'
export * as awards from './api/awards'
export * as awardsProgressOverview from './api/awardsProgressOverview'
export * as bulk from './api/bulk'
export * as organizations from './api/organizations'
export * as codeLists from './api/code-lists'
export * as common from './api/common'
export * as leaders from './api/leaders'
export * as leadersOverview from './api/leadersOverview'
export * as participants from './api/participants'
export * as persons from './api/persons'
export * as tasks from './api/tasks'
export * as assessor from './api/assessor'
export * as assessors from './api/assessors'
export * as announcements from './api/announcements'
export * as residentialProjects from './api/residential-projects'
export * as configuration from './api/configuration'
export * as payments from './api/payments'
export * as parentalConsent from './api/parental-consent'
export * as contacts from './api/contacts'
export * as profileQuestions from './api/profile-questions'
export * as blobs from './api/blobs'
export * as reports from './api/reports'
export * as search from './api/search'
export * as translationsManagement from './api/translations-management'
export * as apiKeys from './api/api-keys'
export * as messages from './api/messages'
export * as translations from './api/translations'
export * as metrics from './api/metrics'
export * as badges from './api/badges'
export * as labels from './api/labels'
export * as lists from './api/lists'

/* eslint-enable */

export default combineReducers({
  actions,
  activities,
  ajEvents,
  ajTemplates,
  assessor,
  assessors,
  announcements,
  awards,
  awardsProgressOverview,
  bulk,
  blobs,
  codeLists,
  common,
  configuration,
  contacts,
  leaders,
  leadersOverview,
  organizations,
  parentalConsent,
  participants,
  payments,
  persons,
  profileQuestions,
  reports,
  residentialProjects,
  search,
  tasks,
  dataImport,
  translationsManagement,
  apiKeys,
  messages,
  translations,
  metrics,
  badges,
  labels,
  lists
})
